/**
 * Copies content to clipboard in both HTML and plain text formats
 * @param {string} html - The HTML content to copy
 * @returns {Promise<void>}
 * @throws {Error} If clipboard access is denied or not supported
 */
export async function copyToClipboard(html: string): Promise<void> {
  // For browsers that support the modern Clipboard API
  if (navigator.clipboard && window.ClipboardItem) {
    const clipboardItem = new ClipboardItem({
      "text/html": new Blob([html], { type: "text/html" }),
      "text/plain": new Blob([html.replace(/<[^>]+>/g, "")], {
        type: "text/plain",
      }),
    });

    await navigator.clipboard.write([clipboardItem]);
    return;
  }

  // Fallback for browsers that only support text/plain
  if (navigator.clipboard && navigator.clipboard.writeText) {
    const plainText = html.replace(/<[^>]+>/g, "");
    await navigator.clipboard.writeText(plainText);
    return;
  }

  throw new Error("Clipboard API not supported in this browser");
}
